'use strict';

import React from 'react';

//require('styles//Infos.css');

class InfosComponent extends React.Component {
	constructor(props){
	  	super(props)
	  	this.state = {
	  		url: '',
	    	latitude: '',
	    	longitude: '',
	    	description: ''
	  	}
	}

	componentDidMount(){
	  	PubSub.subscribe('STATUS', (e,d) => {
	    	//console.log(d)
	    	if(d.type == "LOCATION_INFO"){
	      		this.setState({
	      			url: d.data.url,
	        		latitude: d.data.latitude,
	        		longitude: d.data.longitude,
	        		shortDescription: d.data.shortDescription
	      		})
	    	}
	  	})
	}
	render() {
		if(!this.state.latitude){
			return (
				<div></div>
			)
		}else{
			return (
				<div className="infos">
					<a target="_blank" href={this.state.url}>
						<span className="location">
							{this.state.latitude},{this.state.longitude}
						</span>, 
						<span className="location-info">
							{this.state.shortDescription}
						</span>
					</a>
				</div>
			);
		}
		
	}
}

InfosComponent.displayName = 'InfosComponent';

// Uncomment properties you need
// InfosComponent.propTypes = {};
// InfosComponent.defaultProps = {};

export default InfosComponent;



// WEBPACK FOOTER //
// ./src/components/Infos.js